__turbopack_context__.v({
  "active": "YhMPxG_active",
  "endpoint": "YhMPxG_endpoint",
  "hashmark": "YhMPxG_hashmark",
  "headers": "YhMPxG_headers",
  "link": "YhMPxG_link",
  "listItem": "YhMPxG_listItem",
  "parentItem": "YhMPxG_parentItem",
  "title": "YhMPxG_title",
});
